import packaging from "./packaging.json";
import drawerBox from "../Assets/products/package-icons/drawer box.webp";
import paperCanister from "../Assets/products/package-icons/paper canister.webp";
import plasticBottle from "../Assets/products/package-icons/plastic bottle.webp";
import resealablePouch from "../Assets/products/package-icons/resealable pouch.webp";
import perforatedBox from "../Assets/products/package-icons/perforated box.webp";
import kraftPaperBox from "../Assets/products/package-icons/kraft paper box.webp";
import candyWrapper from "../Assets/products/package-icons/candy wrapper.webp";
import paperEnvelope from "../Assets/products/package-icons/paper envelope.webp";
import mailerBox from "../Assets/products/package-icons/mailer box.webp";
import plasticSprayBottle from "../Assets/products/package-icons/plastic spray bottle.webp";
import metalBottle from "../Assets/products/package-icons/metal spray bottle.webp";
import plasticTube from "../Assets/products/package-icons/plastic tube.webp";
import clothBag from "../Assets/products/package-icons/cloth bag.webp";
import paperBox from "../Assets/products/package-icons/paper box.webp";
import plasticBox from "../Assets/products/package-icons/plastic box.webp";

const illustrations = {
  drawerBox, paperCanister, plasticBottle, resealablePouch, perforatedBox,
  kraftPaperBox, candyWrapper, paperEnvelope, mailerBox,
  plasticSprayBottle, metalBottle, plasticTube, clothBag, paperBox, plasticBox,
};

// All capability labels and artwork come from the shared registry. Null images
// are intentional text-only packaging types, never substitute illustrations.
export const PACKAGING_TYPES = Object.fromEntries(
  Object.entries(packaging.types).map(([key, type]) => [key, {
    ...type,
    key,
    image: type.image === null ? null : illustrations[key],
  }])
);

const optionId = key => key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

function resolveOption(option) {
  const combination = typeof option !== "string";
  const keys = combination ? option.items : [option];
  const items = keys.map(key => PACKAGING_TYPES[key]);
  return {
    id: keys.map(optionId).join("-plus-"),
    name: items.map(item => item.label).join(" + "),
    type: combination ? "combination" : (items[0].image === null ? "text" : "single"),
    items,
  };
}

// Explicit SKU mappings take priority over product names and categories. An
// options array on one SKU replaces its preset, supporting future exceptions.
export const packagingOptionsBySku = Object.fromEntries(
  Object.entries(packaging.bySku).map(([sku, config]) => [sku,
    (config.options !== undefined ? config.options : packaging.presets[config.preset]).map(resolveOption),
  ])
);

// No guessed fallback: every catalog SKU must pass the coverage check.
export const getPackagingOptions = sku => packagingOptionsBySku[sku];

export function getPackagingNote(sku) {
  const availability = "Packaging availability may vary by product configuration and order quantity.";
  const supportsEnvelope = packagingOptionsBySku[sku]?.some(option => option.items.some(item => item.key === "paperEnvelope"));
  return packaging.bySku[sku]?.preset === "sheets" && supportsEnvelope
    ? `${availability} Packs of up to 30 sheets can use paper envelopes. Packs of more than 30 sheets require boxes or pouches.`
    : availability;
}
